import React from "react"
import { Wave } from "react-animated-text"
import Aos from "aos"
import styles from "./TeamPage.module.css"
import Illustration from "../Projectsllustration"
import { database } from "../../../../firebase"
import "./TeamPage.css"
import "aos/dist/aos.css"

const ContentTeam = () => {
  const [width, setWidth] = React.useState()
  React.useEffect(() => {
    setWidth(window.innerWidth)
  }, [])
  const updateDimensions = () => {
    setWidth(window.innerWidth)
  }
  const updateWidth = () => {
    setWidth(window.innerWidth)
  }

  React.useEffect(() => {
    window.addEventListener("resize", updateWidth)
    return () => {
      window.removeEventListener("resize", updateDimensions)
    }
  }, [width])

  React.useEffect(() => {
    Aos.init({ duration: 1200 })
  }, [])

  const [image, setimage] = React.useState([])

  React.useEffect(async () => {
    database.team
      .where("team", "==", "project")
      .orderBy("name", "asc")
      .onSnapshot((querySnapshot) => {
        const arr1 = []
        querySnapshot.forEach((doc) => {
          const { URL } = doc.data()
          arr1.push(URL)
        })
        setimage(arr1)
      })
  }, [])
  const text = `Projects Team`
  return (
    <>
      <div className={styles.mainContainer}>
        <div className={styles.pageHeading}>
          <span className={styles.heading}>
            <Wave
              text={text}
              effect="stretch"
              iterations={1}
              effectChange={2}
            />
          </span>
        </div>
        <div className={styles.container}>
          {width > 768 && <Illustration />}
          <div className={styles.subContainer}>
            {width <= 768 && <Illustration />}
            <div className={styles.para}>
              You're going to implement numerous magical changes and
              mind-provoking thoughts with your words and sentences here. The
              work allotted under this vertical is fascinating. Suppose you're a
              part of this magical train. In that case, you're going to prepare
              excellent content for the Club in writing informative articles,
              preparing innosights materials, events descriptions,
              heart-reaching info to bring awareness of the Club's progress
              among our spectators' uncountable interesting tasks coming up.
            </div>
          </div>
        </div>
      </div>
      <section className="team" data-aos="fade-up">
        <h1 className="teamHeading" data-aos="fade-up">
          Core Team Members
        </h1>
        <div className="members">
          <div className="member" data-aos="fade-up">
            <img src={image[1]} alt="Abhay Kumar Verma" />
            <div className="memberName">
              <span>Abhay Kumar Verma</span>
            </div>
            <div className="status">
              <span>Mentor</span>
            </div>
            <div className="memberPhone">9456100181</div>
          </div>
          <div className="member" data-aos="fade-up">
            <img src={image[0]} alt="Himanshu Singodia " />
            <div className="memberName">
              <span>Himanshu Singodia </span>
            </div>
            <div className="status">
              <span>Head</span>
            </div>
            <div className="memberPhone">8696645774</div>
          </div>
          <div className="member" data-aos="fade-up">
            <img src={image[2]} alt="Gourishetty Meher Pradeepthi " />
            <div className="memberName">
              <span>Gourishetty Meher Pradeepthi </span>
            </div>
            <div className="status">
              <span>Project Advisor</span>
            </div>
            <div className="memberPhone">9391679694</div>
          </div>
          <div className="member" data-aos="fade-up">
            <img src={image[3]} alt="Kuldeep Singh " />
            <div className="memberName">
              <span>Kuldeep Singh </span>
            </div>
            <div className="status">
              <span>Project Advisor </span>
            </div>
            <div className="memberPhone">7055771614</div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ContentTeam
